import React from "react";

import { useTranslation } from "utils";

import { Anchor, Carousel, Icon, Typography } from "components";

const facts = [
  { key: "fact1", sourceUrl: "https://www.ardalpha.de/wissen/natur/tiere/steckbrief-regenwurm-regenwuermer-koerperbau-fortpflanzung-ernaehrung-100.html" },
  { key: "fact2", sourceUrl: "https://www.wsl.ch/de/news/zwei-drittel-der-weltweiten-artenvielfalt-lebt-im-boden/" },
  { key: "fact3", sourceUrl: "https://www.deutschland.de/de/topic/umwelt/landwirtschaft-in-deutschland-zehn-fakten" },
  { key: "fact4", sourceUrl: "https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0329529&utm_source=pr&utm_medium=email&utm_campaign=plos006" },
  { key: "fact5", sourceUrl: "https://www.fibl.org/fileadmin/documents/shop/1314-humuswirtschaft.pdf" },
  { key: "fact6", sourceUrl: "https://www.fibl.org/fileadmin/documents/shop/1314-humuswirtschaft.pdf" },
  { key: "fact7", sourceUrl: "https://facts.net/earth-and-life-science/biology-earth-and-life-science/38-facts-about-rhizosphere/" },
  { key: "fact8", sourceUrl: "https://www.theguardian.com/science/2026/jun/11/arbuscular-mycorrhizal-fungi-plant-life-climate-global-mapping-study" },
  { key: "fact9", sourceUrl: "https://www.theguardian.com/environment/2024/apr/19/scientists-wildlife-sounds-underground-species-soil-aoe" },
] as const;

export const ProcessingFacts = () => {
  const { t } = useTranslation("docScans");

  return (
    <div className="doc-scan-fact-slider" data-testid="processing-fact">
      {/* @ts-expect-error need to convert Carousel to tsx */}
      <Carousel autoplay infinite slidesToShow={1}>
        {facts.map(({ key, sourceUrl }) => (
          <div key={key} className="doc-scan-fact-card">
            <Typography variant="paragraph-s" color="grey-600" className="doc-scan-fact-label">
              {t("processing.facts.label")}
            </Typography>
            <Icon iconName="tabler/bulb" size="m" />
            <Typography variant="paragraph-m" className="center">
              {t(`processing.facts.${key}`)}
            </Typography>
            <Anchor className="doc-scan-fact-source" href={sourceUrl} target="_blank">
              <Typography variant="paragraph-m" color="grey-600">
                {t("processing.facts.sourceLabel")}
              </Typography>
            </Anchor>
          </div>
        ))}
      </Carousel>
    </div>
  );
};
